import { __decorate, __metadata } from "tslib";
import { SerializableObject } from '../../decorators';
import { LinearVelocity } from '../../values';
import { SensorObject } from '../SensorObject';
/**
 * The linear velocity sensors provides on each reading the linear velocity of the device along all three axes.
 * @category data
 */
let LinearVelocitySensor = class LinearVelocitySensor extends SensorObject {
  constructor(uid, value, frequency, displayName) {
    super(uid, value !== null && value !== void 0 ? value : new LinearVelocity(), frequency, displayName);
  }
};
LinearVelocitySensor = __decorate([SerializableObject(), __metadata("design:paramtypes", [String, LinearVelocity, Number, String])], LinearVelocitySensor);
export { LinearVelocitySensor };